import { ENV } from '@omni/kit/Environment';

/**
 * Retuns a shortlink string
 *
 * To enable universal link support, the domain prefix should be the WebApp custom_path
 * ref: https://subsplash.atlassian.net/wiki/spaces/CS/pages/1351778660/Universal+Shortlinks
 */
export default ({
  shortCode,
  customPath,
}: {
  shortCode?: string;
  customPath?: string;
}): string => {
  if (!shortCode) {
    return '';
  }

  let domainPrefix = '';

  if (customPath) {
    domainPrefix = `${customPath}.`;
  }

  switch (ENV) {
    case 'prod':
      return `https://${domainPrefix}subspla.sh/${shortCode}`;

    case 'stage':
      return `https://${domainPrefix}stage.subspla.sh/${shortCode}`;

    default:
      return `https://${domainPrefix}dev.subspla.sh/${shortCode}`;
  }
};
